/** Borghi pilota provincia Teramo — home, admin, scroll borghi. */
export const TE_PILOT_BORGHI = [
  { slug: "campli", name: "Campli" },
  { slug: "crognaleto", name: "Crognaleto" },
  { slug: "pietracamela", name: "Pietracamela" },
  { slug: "mosciano-sant-angelo", name: "Mosciano Sant'Angelo" },
  { slug: "castiglione-messer-raimondo", name: "Castiglione Messer Raimondo" },
  { slug: "castelli", name: "Castelli" },
  { slug: "civitella-del-tronto", name: "Civitella del Tronto" },
  { slug: "torricella-sicura", name: "Torricella Sicura" },
  { slug: "montorio-al-vomano", name: "Montorio al Vomano" },
  { slug: "rocca-santa-maria", name: "Rocca Santa Maria" },
];

export const TE_PILOT_SLUGS = TE_PILOT_BORGHI.map((b) => b.slug);

export const TE_PILOT_NAMES = Object.fromEntries(TE_PILOT_BORGHI.map((b) => [b.slug, b.name]));

/** Borghi curati del Gran Sasso aquilano — visibili in «Borghi consigliati» sulla home. */
export const AQ_GRAN_SASSO_BORGHI = [
  {
    slug: "campo-imperatore",
    name: "Campo Imperatore",
    hero: "/hero/campo-imperatore.png",
    teaser: "Il Piccolo Tibet del Gran Sasso: funivia, set di Trinità, sentieri e pascoli d'altura.",
  },
  {
    slug: "assergi",
    name: "Assergi",
    hero: "/hero/assergi.jpg",
    teaser: "Porta occidentale del Gran Sasso: mura trecentesche e Santuario di San Giovanni Paolo II.",
  },
  {
    slug: "santo-stefano-di-sessanio",
    name: "Santo Stefano di Sessanio",
    hero: "/hero/santo-stefano-di-sessanio.jpg",
    teaser: "Borgo mediceo della Baronia, tra Campo Imperatore e Rocca Calascio.",
  },
  {
    slug: "calascio",
    name: "Calascio",
    hero: "/hero/calascio.png",
  },
  {
    slug: "castel-del-monte",
    name: "Castel del Monte",
    hero: "/hero/castel-del-monte.png",
  },
  {
    slug: "paganica",
    name: "Paganica",
    hero: "/hero/paganica.jpg",
    teaser:
      "Frazione dell'Aquila sul Raiale: santuario rupestre della Madonna d'Appari, zafferano DOP e gole verso il Gran Sasso.",
  },
];

export const AQ_GRAN_SASSO_SLUGS = AQ_GRAN_SASSO_BORGHI.map((b) => b.slug);

export const AQ_GRAN_SASSO_NAMES = Object.fromEntries(AQ_GRAN_SASSO_BORGHI.map((b) => [b.slug, b.name]));

/**
 * Frazioni aquilane con foto verificate in archivio (HERO / uploads Assergi).
 * Usate nella riga home «Le frazioni del territorio» — non inventare path.
 */
export const AQ_FRAZIONI_CON_FOTO = [
  {
    slug: "assergi__san-pietro-della-jenca",
    name: "San Pietro della Jenca",
    comune_slug: "assergi",
    href: "/frazione/assergi__san-pietro-della-jenca",
    hero: "/hero/assergi.jpg",
    sottotitolo: "Assergi (AQ) · Gran Sasso",
    teaser:
      "Santuario di San Giovanni Paolo II a 1.160 m: luogo di pellegrinaggio sul Gran Sasso aquilano.",
  },
];

/**
 * Frazioni TE con foto verificate in archivio pubblico — riga home «Le frazioni del territorio».
 * Path reali sotto /images/… · non usare homepage 6amico.com come fallback.
 */
export const TE_FRAZIONI_CON_FOTO = [
  {
    slug: "pietracamela__intermesoli",
    name: "Intermesoli",
    comune_slug: "pietracamela",
    href: "/frazione/pietracamela__intermesoli",
    hero: "/hero/pietracamela.jpg",
    sottotitolo: "Pietracamela (TE) · Montagna",
    teaser:
      "Intermesoli, a 770 m s.l.m., vanta un'antica origine e una storia indissolubilmente legata ai boschi e al commercio storico della lana d'Appennino.",
  },
  {
    slug: "pietracamela__prati-di-tivo",
    name: "Prati di Tivo",
    comune_slug: "pietracamela",
    href: "/frazione/pietracamela__prati-di-tivo",
    hero: "/hero/pietracamela-bosco.jpg",
    sottotitolo: "Pietracamela (TE) · Outdoor",
    teaser:
      "Rinomata frazione montana del comune di Pietracamela situata a circa 1.450 metri di altitudine ai piedi del Gran Sasso d'Italia, culla dell'alpinismo e dello sci.",
  },
  {
    slug: "rocca-santa-maria__ceppo",
    name: "Il Ceppo",
    comune_slug: "rocca-santa-maria",
    href: "/frazione/rocca-santa-maria__ceppo",
    hero: "/images/rocca-santa-maria/ceppo-rifugio-piazzale.jpg",
    sottotitolo: "Rocca Santa Maria (TE) · Montagna",
    teaser:
      "Porta d'accesso ai boschi della Laga e alle Cascate della Morricana, celebre per la Sagra del Fungo Porcino.",
  },
  {
    slug: "civitella-del-tronto__ripe",
    name: "Ripe di Civitella",
    comune_slug: "civitella-del-tronto",
    href: "/frazione/civitella-del-tronto__ripe",
    hero: "/images/civitella-del-tronto/gole-salinello/IMG_20230723_100233.jpg",
    sottotitolo: "Civitella del Tronto (TE) · Outdoor",
    teaser:
      "Incastonata nella Riserva delle Gole del Salinello, punto di partenza per trekking storici ed escursioni speleologiche.",
  },
];

/** Comuni da cui attingere frazioni/borghi con foto per la home (TE pilota + AQ Gran Sasso). */
export const CURATED_FRAZIONI_COMUNE_SLUGS = [...TE_PILOT_SLUGS, ...AQ_GRAN_SASSO_SLUGS];

export const CURATED_FRAZIONI_DISPLAY_NAMES = {
  ...TE_PILOT_NAMES,
  ...AQ_GRAN_SASSO_NAMES,
};

/** Copertina Assisi — esterni Basilica / complesso (foto panoramica, non dettaglio muretto). */
export const ASSISI_SACRO_CONVENTO_COVER =
  "/images/assisi/basilica-san-francesco/esterni/IMG20260117160024_BURST000_COVER.jpg";

/** Copertine delle schede autonome Assisi — mosaico lightbox della scheda comune. */
export const ASSISI_GALLERY = [
  ASSISI_SACRO_CONVENTO_COVER,
  "/images/assisi/basilica-san-francesco/esterni/IMG20260117160339.jpg",
  "/images/assisi/cripta-san-francesco/cripta-navata.jpg",
  "/images/assisi/cattedrale-san-rufino/IMG20260117154857.jpg",
  "/images/assisi/santuario-spogliazione/IMG20260117154957.jpg",
  "/images/assisi/carlo-acutis-tomba.jpg",
  "/images/assisi/presepe-castelli/IMG20260117160733.jpg",
  "/images/assisi/presepe-castelli/presepe-piazza-basilica.jpg",
  "/images/assisi/vicolo-angelini.jpg",
];

/** Meta Umbria in vetrina home · scheda comune Assisi. */
export const ASSISI_HOME_METE = [
  {
    slug: "assisi",
    name: "Assisi",
    comuneSlug: "assisi",
    href: "/comune/assisi",
    hero: ASSISI_SACRO_CONVENTO_COVER,
    badge: "Meta raccomandata · Umbria",
    teaser: "Città di San Francesco: basiliche, storia e Presepe monumentale di Castelli.",
    relatedSlugs: ["assisi-san-francesco", "assisi-storia-origini"],
    twin: {
      slug: "castelli",
      name: "Presepe di Castelli",
      href: "/comune/castelli",
      label: "Gemellaggio Abruzzo–Umbria",
    },
  },
];

/** Copertina Torre del Cerrano — vetrina home costa teramana (4 m s.l.m.). */
export const TORRE_DEL_CERRANO_COVER = "/images/torre-del-cerrano/cerrano-01.jpg";

/** Meta costa TE in vetrina home · AMP + Comuni Amici Pineto/Silvi/Atri. */
export const TORRE_DEL_CERRANO_HOME_METE = [
  {
    slug: "teramo__torre-del-cerrano",
    name: "Torre del Cerrano",
    regione: "Abruzzo",
    provincia: "TE",
    categoria: "Borghi Consigliati - Costa",
    href: "/frazione/teramo__torre-del-cerrano",
    hero: TORRE_DEL_CERRANO_COVER,
    badge: "AREA MARINA PROTETTA",
    teaser:
      "Antico torrione aragonese del XVI secolo e porto romano sommerso, incastonato tra le dune della costa teramana.",
    relatedSlugs: ["pineto", "silvi", "atri"],
    twin: {
      slug: "pineto",
      name: "Pineto · Silvi · Atri",
      href: "/relazioni-territorio#comuni-amici-costa",
      label: "COMUNI AMICI DELLA COSTA",
    },
  },
];

/** Copertina Castel Trosino — vetrina home, frazione di Ascoli Piceno. */
export const CASTEL_TROSINO_COVER = "/images/castel-trosino/castel-trosino-panorama.jpg";

/** Meta Marche in vetrina home · borgo di travertino e necropoli longobarda. */
export const CASTEL_TROSINO_HOME_METE = [
  {
    slug: "ascoli-piceno__castel-trosino",
    name: "Castel Trosino",
    comuneSlug: "ascoli-piceno",
    regione: "Marche",
    provincia: "AP",
    categoria: "Borghi Consigliati · Piceno",
    href: "/frazione/ascoli-piceno__castel-trosino",
    hero: CASTEL_TROSINO_COVER,
    badge: "Necropoli longobarda · Marche",
    teaser:
      "Castrum Trosini a 426 m: presidio longobardo dal 578, necropoli di Santo Stefano e vie dell'acqua del Castellano.",
  },
];

/**
 * Banner benvenuto dinamico — rotazione a caso al mount.
 * Route verificate (App.js / DATABASE_TERRITORIO_DEFAULT):
 * comuni → `/comune/:slug` · Castel Trosino → `/frazione/ascoli-piceno__castel-trosino`.
 */
export const BANNER_BENVENUTO_BORGHI = [
  { slug: "torricella-sicura", nome: "Torricella Sicura", href: "/comune/torricella-sicura" },
  { slug: "campli", nome: "Campli", href: "/comune/campli" },
  { slug: "civitella-del-tronto", nome: "Civitella del Tronto", href: "/comune/civitella-del-tronto" },
  { slug: "crognaleto", nome: "Crognaleto", href: "/comune/crognaleto" },
  { slug: "mosciano-sant-angelo", nome: "Mosciano Sant'Angelo", href: "/comune/mosciano-sant-angelo" },
  {
    slug: "ascoli-piceno__castel-trosino",
    nome: "Castel Trosino",
    href: "/frazione/ascoli-piceno__castel-trosino",
  },
  {
    slug: "castiglione-messer-raimondo",
    nome: "Castiglione Messer Raimondo",
    href: "/comune/castiglione-messer-raimondo",
  },
];

/** Home · Cicerone · Borghi consigliati (Assisi + Cerrano + Castel Trosino + Gran Sasso + TE pilota). */
export const HOME_BORGHI_CONSIGLIATI = [
  ...ASSISI_HOME_METE,
  ...TORRE_DEL_CERRANO_HOME_METE,
  ...CASTEL_TROSINO_HOME_METE,
  ...AQ_GRAN_SASSO_BORGHI,
  ...TE_PILOT_BORGHI,
];

/** Descrizioni brevi per «I borghi del territorio» sulla home. */
export const TE_PILOT_DESC_BY_SLUG = {
  pietracamela:
    "Ai piedi del Corno Piccolo, pietra, alpinismo e paesaggio identitario nel cuore del Gran Sasso.",
  "castiglione-messer-raimondo":
    "Un'affascinante porta gentile tra le colline della Val Fino, ricca di storia e tradizioni rurali.",
  castelli:
    "La ceramica, le botteghe e il paesaggio ai piedi del Gran Sasso definiscono un laboratorio diffuso.",
  "civitella-del-tronto":
    "La fortezza borbonica domina il borgo e apre una rotta tra storia militare, artigianato e panorami.",
  "torricella-sicura":
    "Tra Gran Sasso e Monti della Laga: frazioni storiche, memoria sismica e tradizioni enogastronomiche.",
  campli:
    "Scala Santa, palazzi storici e tradizioni popolari nel cuore culturale della provincia teramana.",
  crognaleto:
    "Borghi montani, faggete e percorsi verso il Gran Sasso custodiscono memoria, natura e comunità.",
  "mosciano-sant-angelo":
    "Tra costa e colline, Mosciano connette ospitalità, imprese locali e percorsi del territorio teramano.",
  "montorio-al-vomano":
    "Valle del Vomano, tradizioni enogastronomiche e la storica Pizza Dolce — memoria viva accanto a Campli.",
  "rocca-santa-maria":
    "Borgo montano tra Laga e Vomano: frazioni sparse, natura e radici contadine nel cuore dell'Appennino teramano.",
  "santo-stefano-di-sessanio":
    "Borgo mediceo della Baronia, tra Campo Imperatore e Rocca Calascio.",
  calascio:
    "Borgo della Baronia ai piedi di Rocca Calascio: chiesa ottagonale di Santa Maria della Pietà e sentieri della transumanza.",
  "castel-del-monte":
    "Capitale dei pastori e porta orientale dell'altopiano: Canyon dello Scoppaturo e Cammino del Gran Sasso.",
  "campo-imperatore":
    "Il Piccolo Tibet del Gran Sasso: funivia, set di Trinità, sentieri e pascoli d'altura.",
  assergi:
    "Porta occidentale del Gran Sasso: mura trecentesche e, a San Pietro della Jenca, il Santuario di San Giovanni Paolo II.",
  paganica:
    "Frazione dell'Aquila sul Raiale: santuario rupestre della Madonna d'Appari, zafferano DOP e gole verso il Gran Sasso.",
  "assisi-san-francesco":
    "Sacro Convento e Basilica Papale di San Francesco: copertina della vetrina Assisi e ponte con il Presepe monumentale di Castelli.",
  "assisi-storia-origini":
    "Storia di Assisi dalle origini romane alla fabbrica di San Francesco: meta raccomandata collegata al gemellaggio Abruzzo–Umbria.",
  assisi:
    "Città di San Francesco: Sacro Convento, basiliche e il Presepe monumentale in ceramica di Castelli.",
  "teramo__torre-del-cerrano":
    "Antico torrione aragonese del XVI secolo e porto romano sommerso, incastonato tra le dune della costa teramana.",
  "torre-del-cerrano":
    "Antico torrione aragonese del XVI secolo e porto romano sommerso, incastonato tra le dune della costa teramana.",
  "ascoli-piceno__castel-trosino":
    "Castrum Trosini a 426 m: presidio longobardo dal 578, necropoli di Santo Stefano e vie dell'acqua del Castellano.",
  "castel-trosino":
    "Castrum Trosini a 426 m: presidio longobardo dal 578, necropoli di Santo Stefano e vie dell'acqua del Castellano.",
};
